// extracted by mini-css-extract-plugin
module.exports = {"container":"ReviewSummary_container__LYPJ2","star":"ReviewSummary_star__Iq_pq","chevronRight":"ReviewSummary_chevronRight__wxcJq"};